import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as dimensionFilter from '../../plugin'
import type { Plugin } from '../plugin'

/** Clears the active selection when its Current List filter is removed. */
export const clearSelectionOnFilterCleared = store.effects.create(
  <TTypeParams extends Plugin.TypeParams>(
    _feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
    selectionStorage: dimensionFilter.Plugin['selectionStorage'],
  ) =>
    plugin.collection.plugins.currentListPlugin.editedParams.actions.setFilters.success
      .observe()
      .pipe(
        rxjsUtils.latestFrom(action => ({
          action: rxjs.of(action),
          filters:
            plugin.collection.plugins.currentListPlugin.editedParams.selectors
              .filters.asObservable,
          selectionLookup: plugin.selectors.selectionLookup.asObservable,
        })),
        rxjs.map(({ action, filters, selectionLookup }) => {
          const hasSelections = Object.values(selectionLookup).some(
            recordIds => !!recordIds?.length,
          )

          return plugin.currentListFilter.get(filters) !== undefined ||
            !hasSelections
            ? store.effects.SKIP
            : selectionStorage.actions.setLookup.from(action).create({})
        }),
      ),
)
